"use strict"

import React, { useEffect, useState } from "react"
import { Modal, Button } from "react-bootstrap"

import AxesLabelsColumn from "./AxesLabelsColumn"
import AxesTagsColumn from "./AxesTagsColumn"
import NewOriginalDropdown from "./NewOriginalDropdown"

import { isLTPM } from "../../../../components/shared_components_registration"
import { getMatchingTrend, getTagKey } from "../../resources/utils"
const registration = {
  y1_axis_label: (intl) => (isLTPM ? intl.formatMessage({ id: "graphing.y1.axis.label" }) : "Y1 Axis Label"),
  y2_axis_label: (intl) => (isLTPM ? intl.formatMessage({ id: "graphing.y2.axis.label" }) : "Y2 Axis Label"),
  title_label: (intl) => (isLTPM ? intl.formatMessage({ id: "general.title" }) : "Title"),
  reset_graph_settings: (intl) =>
    isLTPM ? intl.formatMessage({ id: "graphing.reset.graph.settings" }) : "Reset Graph Settings",
  update_graph_settings: (intl) =>
    isLTPM ? intl.formatMessage({ id: "graphing.update.graph.settings" }) : "Update Graph Settings",
  close_text: (intl) => (isLTPM ? intl.formatMessage({ id: "general.closeButton" }) : "Close"),
}

export default function AxesAssignmentModal({
  show,
  onHide,
  intl,
  disable_title_edit = true,
  graphKey = {},
  newGraphKey = {},
  onSubmit,
}) {
  const [newTagAssignment, setNewTagAssignment] = useState([])
  const [newTitle, setNewTitle] = useState("")
  const [newAxis1Label, setNewAxis1Label] = useState("")
  const [newAxis2Label, setNewAxis2Label] = useState("")

  const [ogTagAssignment, setOGTagAssignment] = useState([])
  const [ogTitle, setOGTitle] = useState("")
  const [ogAxis1Label, setOGAxis1Label] = useState("")
  const [ogAxis2Label, setOGAxis2Label] = useState("")

  const [newTrendsList, setNewTrendsList] = useState([])
  const [useNewTags, setUseNewTags] = useState(true)
  const [useNewTitle, setUseNewTitle] = useState(true)
  const [useNewLabel1, setUseNewLabel1] = useState(true)
  const [useNewLabel2, setUseNewLabel2] = useState(true)

  const getInitialState = () => {
    setUseNewTags(true)
    setUseNewLabel1(true)
    setUseNewLabel2(true)
    setUseNewTitle(true)

    const og_tags = (graphKey.observations || []).map((obv) => getTagKey(obv))
    const new_tags = (newGraphKey.observations || []).filter((obv) => !og_tags.includes(getTagKey(obv)))
    setNewTrendsList(new_tags.map((sel) => getTagKey(sel)))

    // New Settings
    const newTags = newGraphKey.observations || []
    setNewTagAssignment(newTags)
    setNewAxis1Label(newGraphKey.axis1label)
    setNewAxis2Label(newGraphKey.axis2label)
    setNewTitle(newGraphKey.title)
    // -- New Settings

    // Original Settings (plus new tags)
    const oldTags = [...(graphKey.observations || []), ...new_tags]
    setOGTagAssignment(oldTags)
    setOGAxis1Label(graphKey.axis1label)
    setOGAxis2Label(graphKey.axis2label)
    setOGTitle(graphKey.title)
    // --- Original Settings
  }

  useEffect(() => {
    getInitialState()
  }, [])

  const getAxis1Tags = (arr) => arr.filter((obs) => !obs.disabled && !obs.axis2)
  const getAxis2Tags = (arr) => arr.filter((obs) => !obs.disabled && obs.axis2)

  const updateAxisAssignment = (tag_obj) => {
    const tagList = useNewTags ? newTagAssignment : ogTagAssignment
    const setTagList = useNewTags ? setNewTagAssignment : setOGTagAssignment
    const updatedTagList = []
    tagList.forEach((tag) => {
      if (getMatchingTrend(tag, tag_obj)) {
        updatedTagList.push(tag_obj)
      } else {
        updatedTagList.push(tag)
      }
    })
    setTagList(updatedTagList)
  }

  return (
    <Modal
      show={show}
      onHide={onHide}
      style={{ overflowX: "scroll", overflowY: "scroll" }}
      backdrop={"static"}
      size={"xl"}
      dialogClassName={"definitions-modal"}
    >
      <Modal.Header closeButton>
        <Modal.Title>{registration.update_graph_settings(intl)}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className={"row"} style={{ margin: "0", marginBottom: "15px" }}>
          <div className={"col-6"}>
            <div className={"row"} style={{ margin: "0", marginBottom: "15px" }}>
              <div className={"col-3"} style={{ paddingLeft: "0" }}>
                <NewOriginalDropdown
                  isNew={useNewTitle}
                  intl={intl}
                  onSelect={setUseNewTitle}
                  id={"title-toggle"}
                />
              </div>
              <div className={"col-3"} style={{ padding: "0" }}>
                <label>{registration.title_label(intl)}:</label>
              </div>
              <div className={"col-6"} style={{ padding: "0" }}>
                <input
                  type={"text"}
                  value={useNewTitle ? newTitle : ogTitle}
                  disabled={disable_title_edit}
                  onChange={(e) => (useNewTitle ? setNewTitle(e.target.value) : setOGTitle(e.target.value))}
                />
              </div>
            </div>
          </div>
        </div>
        <hr />
        <div className={"row"} style={{ margin: "0", marginBottom: "15px" }}>
          <AxesLabelsColumn
            axisTagList={getAxis1Tags(useNewTags ? newTagAssignment : ogTagAssignment)}
            isNewLabel={useNewLabel1}
            setIsNewLabel={setUseNewLabel1}
            axisLabel={useNewLabel1 ? newAxis1Label : ogAxis1Label}
            onLabelChange={(label) => (useNewLabel1 ? setNewAxis1Label(label) : setOGAxis1Label(label))}
            label={registration.y1_axis_label(intl)}
            intl={intl}
          />
          <AxesLabelsColumn
            axisTagList={getAxis2Tags(useNewTags ? newTagAssignment : ogTagAssignment)}
            isNewLabel={useNewLabel2}
            setIsNewLabel={setUseNewLabel2}
            axisLabel={useNewLabel2 ? newAxis2Label : ogAxis2Label}
            onLabelChange={(label) => (useNewLabel2 ? setNewAxis2Label(label) : setOGAxis2Label(label))}
            label={registration.y2_axis_label(intl)}
            intl={intl}
          />
        </div>
        <hr />
        <div className={"row"} style={{ margin: "0", marginBottom: "10px" }}>
          <div className={"col-6"}>
            <div className={"row"} style={{ margin: "0", marginBottom: "15px" }}>
              <div className={"col-3"} style={{ paddingLeft: "0" }}>
                <NewOriginalDropdown
                  isNew={useNewTags}
                  intl={intl}
                  onSelect={setUseNewTags}
                  id={"axis-assignment-toggle"}
                />
              </div>
            </div>
          </div>
        </div>
        <div className={"row"} style={{ margin: "0" }}>
          <AxesTagsColumn
            axisTagList={getAxis1Tags(useNewTags ? newTagAssignment : ogTagAssignment)}
            newTrendsList={newTrendsList}
            updateAxis={(tag, axis2) => updateAxisAssignment(tag, axis2)}
          />
          <AxesTagsColumn
            axisTagList={getAxis2Tags(useNewTags ? newTagAssignment : ogTagAssignment)}
            newTrendsList={newTrendsList}
            updateAxis={(tag, axis2) => updateAxisAssignment(tag, axis2)}
          />
        </div>
      </Modal.Body>
      <Modal.Footer>
        <div style={{ marginRight: "auto" }}>
          <Button variant="outline-primary" onClick={onHide}>
            {registration.close_text(intl)}
          </Button>
        </div>
        <div style={{ display: "flex", marginLeft: "auto" }}>
          <Button variant={"outline-primary"} onClick={getInitialState} style={{ marginRight: "5px" }}>
            {registration.reset_graph_settings(intl)}
          </Button>
          <Button
            variant="primary"
            onClick={(_) =>
              onSubmit({
                ...newGraphKey,
                title: useNewTitle ? newTitle : ogTitle,
                observations: useNewTags ? newTagAssignment : ogTagAssignment,
                axis1label: useNewLabel1 ? newAxis1Label : ogAxis1Label,
                axis2label: useNewLabel2 ? newAxis2Label : ogAxis2Label,
              })
            }
          >
            {registration.update_graph_settings(intl)}
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  )
}
